import { render, staticRenderFns } from "./MenuContactInfo.vue?vue&type=template&id=5d3ed424&scoped=true&"
import script from "./MenuContactInfo.vue?vue&type=script&lang=js&"
export * from "./MenuContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./MenuContactInfo.vue?vue&type=style&index=0&id=5d3ed424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ed424",
  null
  
)

export default component.exports